import apiClient from './apiClient';

const login = async (email, password, signal) => {
    try {
        const response = await apiClient.post('auth/customer/login', { email, password }, { timeout: 15000, signal });
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.error || error.message)
    }
};

const register = async (userData) => {
    try {
        const response = await apiClient.post('auth/register', userData);
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.error || error.message)
    }
};

const otpRequest = async (path, body, signal) => {
    try {
        const response = await apiClient.post(path, body, { signal, timeout: 15000 });
        return response.data;
    } catch (error) {
        const data = error.response?.data;
        const failure = new Error(data?.error || 'No pudimos conectar con el servidor. Revisá tu conexión e intentá nuevamente.');
        failure.code = data?.code;
        failure.retryAfter = data?.retryAfter || Number(error.response?.headers?.['retry-after']) || 0;
        failure.hasPassword = data?.hasPassword;
        throw failure;
    }
};

// Agrupamos los servicios en un objeto
const authService = {
    login,
    register,
    requestCode: (email, purpose, signal) => otpRequest('auth/otp/request', { email, purpose }, signal),
    verifyCode: (challengeId, code, purpose, signal) => otpRequest('auth/otp/verify', { challengeId, code, purpose }, signal),
    completeRecovery: (challengeId, recoveryToken, action, password, signal) =>
        otpRequest('auth/otp/recovery', { challengeId, recoveryToken, action, password }, signal),
};

export default authService;
